import React from "react";
import CustomButton, {
  OutlineCustomButton,
} from "shared/components/inputButton";
import { formatDateToMMDDYYYY } from "utils/common";

const MusicVideoDocument = ({
  sign,
  setSign,
  contractDetails,
  handleClear,
  onSignSubmit,
}) => {
  const date = formatDateToMMDDYYYY(contractDetails?.payload?.agreementDate);
  const delivery = formatDateToMMDDYYYY(
    contractDetails?.payload?.details?.deliveryDate
  );
  const signedArtistDate = formatDateToMMDDYYYY(
    contractDetails?.payload?.signatures[0]?.dateSigned
  );
  const signedProducerData = formatDateToMMDDYYYY(
    contractDetails?.payload?.signatures[1]?.dateSigned
  );

  const allClauses = [
    {
      name: "copyright",
      title: "COPYRIGHT AND OWNERSHIP",
      content: (
        <>
          <p>
            Upon full payment, the Artist will own the rights to the Music
            Video, including all audio and visual elements. The Producer retains
            the right to use the Music Video for promotional purposes in their
            portfolio and on their website.
          </p>
        </>
      ),
    },
    {
      name: "representation",
      title: "REPRESENTATION AND WARRANTIES",
      content: (
        <>
          <p>
            The Producer warrants that the Music Video will be original and will
            not infringe upon any third-party rights. The Producer shall
            indemnify the Artist against any claims arising from a breach of
            this warranty.
          </p>
        </>
      ),
    },
    {
      name: "",
      title: "scheduleandlocation",
      content: (
        <>
          <p>
            The filming schedule and location will be agreed upon by both
            parties. Any changes to the schedule or location must be mutually
            agreed upon in writing.
          </p>
        </>
      ),
    },
    {
      name: "termination",
      title: "TERMINATION",
      content: (
        <>
          <p>
            If either party breaches any material term of this Agreement, the
            non-breaching party must first serve a written notice detailing the
            breach. The breaching party shall have [
            <strong>
              {contractDetails?.payload?.details?.termination?.day}
            </strong>
            ] days from the date of receipt of such notice to cure the breach.
            If the breaching party fails to remedy the breach within the
            specified period, the non-breaching party may serve a termination
            notice, thereby ending the Agreement. Termination shall not affect
            any rights, remedies, obligations, or liabilities accrued up to the
            date of termination.
          </p>
        </>
      ),
    },
    {
      name: "governmentlaw",
      title: "Government Law",
      content: (
        <>
          <p>
            This Agreement shall be governed by and construed in accordance with
            the laws of [
            <strong>
              {contractDetails?.payload?.details?.governmentlaw?.law}
            </strong>
            ].
          </p>
        </>
      ),
    },
    {
      name: "entireagreement",
      title: " ENTIRE AGREEMENT ",
      content: (
        <>
          <p>
            This Agreement constitutes the entire understanding between the
            parties and supersedes all prior discussions, agreements, or
            understandings of any kind.
          </p>
        </>
      ),
    },
  ];
  const displayedClauses = allClauses.filter((clause) =>
    contractDetails?.payload?.clauses?.some((c) => c.name === clause.name)
  );

  return (
    <div>
      <div className="bg-white shadow-1 p-5 ">
        <h1 className="mb-5 text-center">
          <strong>
            {contractDetails?.payload?.agreementType || "____________"}
          </strong>
        </h1>
        <p className="mb-3">
          This Music Video Agreement ({" "}
          <strong>
            {contractDetails?.payload?.agreementName || "____________"}
          </strong>
          ) is made and entered into as of [{" "}
          <strong>{date || "____________"}</strong>],
        </p>
        <p className="mb-3">By and Between </p>
        <p className="mb-3">
          <strong>
            {contractDetails?.payload?.primaryArtist?.fullLegalName ||
              "____________"}
          </strong>
          , p/k/a{" "}
          <strong>
            {contractDetails?.payload?.primaryArtist?.name || "____________"}
          </strong>{" "}
          (the “<strong>Artist</strong>”), an individual or an entity with an
          address at{" "}
          <strong>
            {contractDetails?.payload?.primaryArtist?.address || "____________"}
          </strong>
        </p>
        <p className="mb-3">And</p>
        <p className="mb-3">
          [{" "}
          <strong>
            {contractDetails?.payload?.details?.director || "____________"}
          </strong>
          ] (“Producer”), an individual or an entity with an address at [
          <strong>
            {contractDetails?.payload?.details?.bussinessAddress ||
              "____________"}
          </strong>
          ].
        </p>
        <h3 className="mt-5 mb-3">1. SCOPE OF WORK</h3>
        <p className="mb-3">
          The Producer agrees to create a music video (“Music Video”) for the
          Artist’s music release titled “[
          <strong>
            {contractDetails?.payload?.details?.realeaseTitle || "____________"}
          </strong>
          ]” (the “Music Release”). The scope of the work includes:
        </p>
        <ul>
          <strong>
            {contractDetails?.payload?.details?.scopeProduction ||
              "____________"}
          </strong>
        </ul>
        <h3 className="mt-5 mb-3">2. COMPENSATION </h3>
        <p className="mb-3">
          The Artist agrees to pay the Producer a total fee of [
          <strong>
            {contractDetails?.payload?.details?.musicVideoFee || "____________"}
          </strong>
          ] for the Music Video (“Production Fee”). Payment shall be made as
          follows:
        </p>
        <ul>
          <li>
            [
            <strong>
              {contractDetails?.payload?.details?.paymentSchedule ||
                "____________"}
            </strong>
            ]
          </li>
        </ul>
        <p className="mb-3">
          The Producer and Artist agree that the quotation attached in Schedule
          A shall represent 100% of the funds required to produce the Music
          Video. This amount represents the Producer’s total anticipated costs
          and profit.
        </p>
        <p>
          Any extra expenses arising from the Producer's mismanagement shall be
          borne by the Producer and will not require any additional payment from
          the Artist.
        </p>
        <p>
          Any extra expenses arising from unforeseeable force majeure events
          shall be covered by the Producer or the Producer's insurance. The
          Artist shall not be liable for such costs.
        </p>
        <p>
          Any extra expenses resulting from the Artist’s schedule changes,
          creative requests, or other actions initiated by the Artist
          (“Additional Expenses”) may be agreed upon in writing by both parties.
          These Additional Expenses are separate from the Production Fee and
          shall be payable [
          <strong>
            {contractDetails?.payload?.details?.paymentTerms || "____________"}
          </strong>
          ].
        </p>
        <h3 className="mt-5 mb-3">3. DELIVERY </h3>
        <p className="mb-3">
          The Producer agrees to deliver the final Music Video to the Artist by
          [
          <strong>
            {contractDetails?.payload?.details?.deliveryDate || "____________"}
          </strong>
          ]. The Video will be delivered in the following format(s):
        </p>
        <ul>
          <li>
            The final video format(s): [
            <strong>
              {contractDetails?.payload?.details?.videoFormat || "____________"}
            </strong>
            ].
          </li>
          <li>
            The delivery method: [i.e. delivered a downloadable version of all
            the required formats electronically]
          </li>
          <li>
            Any additional format: [i.e. any behind-the-scene videos and raw
            footages]
          </li>
        </ul>
        <h3 className="mt-5 mb-3">4. DISPUTE RESOLUTION</h3>
        <p>
          Any disputes arising out of or in connection with this Agreement shall
          first be resolved through good faith negotiations between the parties.
          If the dispute remains unresolved within [
          <strong>
            {contractDetails?.payload?.details?.days || "____________"}
          </strong>
          ] days of written notice, the parties agree to submit the dispute to
          mediation before resorting to litigation or arbitration. Mediation
          shall take place in [
          <strong>
            {contractDetails?.payload?.details?.jurisdiction || "____________"}
          </strong>
          ], and if mediation fails, the dispute shall be finally settled by [
          <strong>
            {contractDetails?.payload?.details?.disputeSettlement ||
              "____________"}
          </strong>
          ] in accordance with the laws of [
          <strong>
            {contractDetails?.payload?.details?.jurisdiction || "____________"}
          </strong>
          ].
        </p>
        {displayedClauses.map((clause, index) => (
          <div key={clause.name}>
            <h3 className="mt-5 mb-3">
              {index + 5}. {clause.title}
            </h3>
            {clause.content}
          </div>
        ))}
        <p className="mt-7 mb-3">ACCEPTED AND AGREED TO BY:</p>
        {/* Artist Section */}
        <p className="mt-6 mb-3">Artist</p>
        <h3 className="mt-6 mb-3">
          <div style={{ position: "relative" }}>
            {contractDetails?.payload?.signatures?.some(
              (sig) => sig.role === "artist"
            ) ? (
              contractDetails.payload.signatures.find(
                (sig) => sig.role === "artist"
              ).signature ? (
                <img
                  src={
                    contractDetails.payload.signatures.find(
                      (sig) => sig.role === "artist"
                    ).signature
                  }
                  style={{ width: "150px", height: "auto" }}
                  alt="Artist Signature"
                />
              ) : (
                <div
                  style={{
                    minWidth: "150px",
                    borderBottom: "1px solid #000",
                    paddingBottom: "4px",
                    fontFamily: "cursive",
                  }}
                >
                  {contractDetails.payload.signatures.find(
                    (sig) => sig.role === "artist"
                  ).typedSignature || " "}
                </div>
              )
            ) : sign.artist?.signature ? (
              <img
                src={sign.artist.signature}
                style={{ width: "150px", height: "auto" }}
                alt="Artist Signature"
              />
            ) : (
              <div
                style={{
                  minWidth: "150px",
                  borderBottom: "1px solid #000",
                  paddingBottom: "4px",
                  fontFamily: "cursive",
                }}
              >
                {sign.artist?.typedSignature || " "}
              </div>
            )}

            {!contractDetails?.payload?.signatures?.some(
              (sig) => sig.role === "artist"
            ) &&
              !sign.artist?.signature &&
              !sign.artist?.typedSignature && (
                <div style={{ marginTop: "8px", display: "flex", gap: "8px" }}>
                  <CustomButton
                    label="Sign"
                    onClick={() => onSignSubmit("artist")}
                    disabled={
                      !!sign.producer?.signature ||
                      !!sign.producer?.typedSignature
                    }
                  />
                </div>
              )}

            {!contractDetails?.payload?.signatures?.some(
              (sig) => sig.role === "artist"
            ) &&
              (sign.artist?.signature || sign.artist?.typedSignature) && (
                <div style={{ marginTop: "8px", display: "flex", gap: "8px" }}>
                  <CustomButton
                    label="Resign"
                    onClick={() => onSignSubmit("artist")}
                    disabled={
                      !!sign.producer?.signature ||
                      !!sign.producer?.typedSignature
                    }
                  />
                  <OutlineCustomButton
                    label="Clear"
                    onClick={() => {
                      if (typeof handleClear === "function") {
                        handleClear("artist");
                      } else {
                        setSign((prev) => ({
                          ...prev,
                          artist: {
                            signature: "",
                            typedSignature: "",
                          },
                        }));
                      }
                    }}
                  />
                </div>
              )}
          </div>
        </h3>

        {/* Producer Section */}
        <p className="mt-6 mb-3">Producer</p>
        <h3 className="mt-6 mb-3">
          <div style={{ position: "relative" }}>
            {contractDetails?.payload?.signatures?.some(
              (sig) => sig.role === "producer"
            ) ? (
              contractDetails.payload.signatures.find(
                (sig) => sig.role === "producer"
              ).signature ? (
                <img
                  src={
                    contractDetails.payload.signatures.find(
                      (sig) => sig.role === "producer"
                    ).signature
                  }
                  style={{ width: "150px", height: "auto" }}
                  alt="Producer Signature"
                />
              ) : (
                <div
                  style={{
                    minWidth: "150px",
                    borderBottom: "1px solid #000",
                    paddingBottom: "4px",
                    fontFamily: "cursive",
                  }}
                >
                  {contractDetails.payload.signatures.find(
                    (sig) => sig.role === "producer"
                  ).typedSignature || " "}
                </div>
              )
            ) : sign.producer?.signature ? (
              <img
                src={sign.producer.signature}
                style={{ width: "150px", height: "auto" }}
                alt="Producer Signature"
              />
            ) : (
              <div
                style={{
                  minWidth: "150px",
                  borderBottom: "1px solid #000",
                  paddingBottom: "4px",
                  fontFamily: "cursive",
                }}
              >
                {sign.producer?.typedSignature || " "}
              </div>
            )}

            {!contractDetails?.payload?.signatures?.some(
              (sig) => sig.role === "producer"
            ) &&
              !sign.producer?.signature &&
              !sign.producer?.typedSignature && (
                <div style={{ marginTop: "8px", display: "flex", gap: "8px" }}>
                  <CustomButton
                    label="Sign"
                    onClick={() => onSignSubmit("producer")}
                    disabled={
                      !!sign.artist?.signature || !!sign.artist?.typedSignature
                    }
                  />
                </div>
              )}

            {!contractDetails?.payload?.signatures?.some(
              (sig) => sig.role === "producer"
            ) &&
              (sign.producer?.signature || sign.producer?.typedSignature) && (
                <div style={{ marginTop: "8px", display: "flex", gap: "8px" }}>
                  <CustomButton
                    label="Resign"
                    onClick={() => onSignSubmit("producer")}
                    disabled={
                      !!sign.artist?.signature || !!sign.artist?.typedSignature
                    }
                  />
                  <OutlineCustomButton
                    label="Clear"
                    onClick={() => {
                      if (typeof handleClear === "function") {
                        handleClear("producer");
                      } else {
                        setSign((prev) => ({
                          ...prev,
                          producer: {
                            signature: "",
                            typedSignature: "",
                          },
                        }));
                      }
                    }}
                  />
                </div>
              )}
          </div>
        </h3>
        <p className="mb-3">
          [
          <strong>
            {contractDetails?.payload?.details?.producerQuotation}
          </strong>
          ]
        </p>
      </div>
    </div>
  );
};

export default MusicVideoDocument;
